import React, { useState, useEffect } from "react";
import { Button } from "../components/ui/button";
import { toast } from "react-toastify";
import "./CopyTradingAccounts.css";

const API_URL = "https://server.majestyfx.com/admin_copyaccounts.php";

const RejectedFollowers = () => {
  const [copyAccounts, setCopyAccounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchCopyAccounts();
  }, []);

  const fetchCopyAccounts = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await fetch(API_URL, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      
      if (data.status === "success") {
        // Filter only rejected/inactive accounts (status === 0)
        const rejectedAccounts = (data.data || []).filter(acc => acc.status === 0 || acc.status === "0");
        setCopyAccounts(rejectedAccounts);
        toast.success(`Loaded ${rejectedAccounts.length} rejected followers`);
      } else {
        throw new Error(data.message || "Failed to fetch copy trading accounts");
      }
    } catch (error) {
      console.error("Error fetching copy accounts:", error);
      setError(error.message);
      toast.error("Failed to load rejected followers");
    } finally {
      setLoading(false);
    }
  };

  const getStatusBadge = (status) => {
    return (
      <span className="status-badge status-inactive">
        Rejected
      </span>
    );
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  if (loading) {
    return (
      <div className="copy-trading-container">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading rejected followers...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="copy-trading-container">
        <div className="error-container">
          <h2>Error Loading Rejected Followers</h2>
          <p>{error}</p>
          <Button onClick={fetchCopyAccounts} className="retry-btn">
            Retry
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="copy-trading-container">
      <div className="page-header">
        <h1>Rejected Followers</h1>
        <div className="header-actions">
          <Button onClick={fetchCopyAccounts} className="refresh-btn">
            <span className="refresh-icon">🔄</span>
            Refresh
          </Button>
        </div>
      </div>

      <div className="accounts-stats">
        <div className="stat-card">
          <h3>Total Rejected Followers</h3>
          <p className="stat-number inactive">{copyAccounts.length}</p>
        </div>
      </div>

      {copyAccounts.length === 0 ? (
        <div className="no-accounts">
          <h3>No Rejected Followers Found</h3>
          <p>There are currently no rejected followers in the system.</p>
        </div>
      ) : (
        <div className="accounts-table-container">
          <table className="accounts-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Email</th>
                <th>Master Account</th>
                <th>Slave Account</th>
                <th>Copy ID</th>
                <th>Volume</th>
                <th>Commission</th>
                <th>Status</th>
                <th>Created Date</th>
              </tr>
            </thead>
            <tbody>
              {copyAccounts.map((account) => (
                <tr key={account.id}>
                  <td>{account.id}</td>
                  <td className="email-cell">{account.email}</td>
                  <td>
                    <div className="account-info">
                      <div className="account-name">{account.mastername}</div>
                      <div className="account-id">ID: {account.mastertrade}</div>
                    </div>
                  </td>
                  <td>
                    <div className="account-info">
                      <div className="account-name">{account.slavename}</div>
                      <div className="account-id">ID: {account.slavetrade}</div>
                    </div>
                  </td>
                  <td>{account.copyid || "N/A"}</td>
                  <td>{account.volume || "N/A"}</td>
                  <td>{account.commission || "N/A"}</td>
                  <td>{getStatusBadge(account.status)}</td>
                  <td>{formatDate(account.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default RejectedFollowers;
